import { axiosInstance } from '@/api/constants.ts';
import { ApiCart } from '@/api/types.ts';

export async function getCart(uuid: string): Promise<ApiCart | null> {
  const { data } = await axiosInstance.get<ApiCart | null>(`/api/cart/${uuid}`);
  return data;
}

export async function createCart() {
  const { data } = await axiosInstance.post<ApiCart>('/api/cart');
  return data;
}

export type UpdateCartRequest = {
  uuid: string;
  manual_check: boolean;
};

export async function updateCart({ uuid, manual_check }: UpdateCartRequest) {
  const { data } = await axiosInstance.patch<void>(`/api/cart/${uuid}`, {
    manual_check,
  });
  return data;
}

export type AddConfiguredSetToCartRequest = {
  uuid: string;
  configuredSetUuid: string;
};

export async function addConfiguredSetToCart({
  uuid,
  configuredSetUuid,
}: AddConfiguredSetToCartRequest) {
  const { data } = await axiosInstance.post<ApiCart>(
    `/api/cart/${uuid}/add/${configuredSetUuid}`,
  );
  return data;
}

export type SetCartItemQuantityRequest = {
  uuid: string;
  cartItemId: number;
  quantity: number;
};

export async function setCartItemQuantity({
  uuid,
  cartItemId,
  quantity,
}: SetCartItemQuantityRequest) {
  const { data } = await axiosInstance.put<ApiCart>(
    `/api/cart/${uuid}/items/${cartItemId}/quantity/${quantity}`,
  );
  return data;
}

export type RemoveCartItemRequest = {
  uuid: string;
  cartItemId: number;
};

export async function removeCartItem({
  uuid,
  cartItemId,
}: RemoveCartItemRequest) {
  const { data } = await axiosInstance.delete<ApiCart>(
    `/api/cart/${uuid}/items/${cartItemId}`,
  );
  return data;
}
